import DOM from '../DOM/DOM'

type TCallback<T extends Node> = (el: T) => void

/**
 * DOM-ba kerülve meghívja a megadott callback-et.
 * @param el                  - Az elem, amit vizsgálunk.
 * @param onConnectedCallback - A callback, ami majd meghívódik.
 * @param willAutoDisconnect  - Automatikusan kikapcsolja az observert az első DOM attach után?
 */
export default function connectedCallback<T extends Node> (
  el: T,
  onConnectedCallback: TCallback<T>,
  willAutoDisconnect = true
): T {
  // Ha már alapból hozzá van adva a DOM-hoz és disconnectelhetünk, akkor csak meg kel lhívni a függvényt, és kész, nem kell példányosítás.
  if (DOM.isAttachedToDOM(el)) {
    onConnectedCallback(el)

    if (willAutoDisconnect) {
      return el
    }
  }

  // Ha még nem volt benne a DOM-ban, akkor kell csinálnunk egy observert.

  // eslint-disable-next-line no-restricted-globals
  const observer = new MutationObserver(() => {
    if (!DOM.isAttachedToDOM(el)) {
      return
    }

    if (willAutoDisconnect) {
      observer.disconnect()
    }

    onConnectedCallback(el)
  })

  observer.observe(document, {
    childList: true,
    subtree: true
  })

  return el
}
